import api from '@/services/api'

export default {
  /**
   * @return {Object} current user
   */
  async getMe () {
    try {
      const res = await api.get('/me')
      return res.data
    } catch (error) {
      if (error.response && error.response.status === 401) {
        return null
      }
      
      throw `Me api service ${error}`
    }
  },
  
  /**
   * Update password
   * @param {String} newPassword 
   */
  async updatePassword (newPassword) {
    try {
      await api.patch('/me/password', { password: newPassword })
    } catch (error) {
      throw `Me api service ${error}`
    }
  },

  /**
   * Get public news
   * @return {Array} news
   */
  async getPublicNews () {
    try {
      const res = await api.get('/me/news')
      return res.data
    } catch (error) {
      throw `Me api service ${error}`
    }
  },

  /**
   * Get public documents
   * @return {Array} documents
   */
  async getPublicDocuments (categoryId = null, search = '') {
    try {
      const res = await api.get('/me/documents', {params: {categoryId, search}})
      return res.data
    } catch (error) {
      throw `Me api service ${error}`
    }
  },

  /**
   * 
   * @param {String} subject 
   * @param {String} content 
   */
  async sendContactEmail (subject, content) {
    try {
      await api.post('/me/contact', {subject, content})
    } catch (error) {
      throw `Me api service ${error}`
    }
  }
}